import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import {Link} from 'react-router-dom'
import { AppBar, Toolbar, Grid, Box,  } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import logo from '../assets/invlogo.png'

const useStyles = makeStyles({
  list: {
    width: 230,
  },
  fullList: {
    width: 'auto',
  },
  color: {
    backgroundColor: '#003469'  ,
color: 'white'    
},
reslogo: {
    height: '30px',   
},
reslink: {
    textDecoration: 'none',
    color: '#213C54',
    fontWeight: 'bold',
    fontSize: '18px',
    fontFamily: 'Poppins',
},
reslink2: {
    textDecoration: 'none',
    color: '#003469',
    fontSize: '18px',
    fontFamily: 'Poppins',
},

});

export default function TemporaryDrawer() {
  const classes = useStyles();
  const [state, setState] = React.useState({    
    left: false,    
  });

  const toggleDrawer = (anchor, open) => event => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };

  const list = anchor => (
    <div className={clsx(classes.list, {
        [classes.fullList]: anchor === 'top' || anchor === 'bottom',
      })}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>                      
              <ListItem key = {1} button divider>
             <Link to="/architectural" className={classes.reslink}>
               Architectural</Link></ListItem>
               <ListItem key = {2} button divider>
               <Link to="/marine" className={classes.reslink}>Marine</Link></ListItem>
               <ListItem key = {3} button divider>
               <Link to="/rigging" className={classes.reslink}>Rigging</Link></ListItem>
               <ListItem key = {4} button divider>
               <Link to="/hardware" className={classes.reslink}>Hardware</Link></ListItem>
               <ListItem key = {4} button divider></ListItem>
               <ListItem key = {5} button divider> 
               <Link to="/" className={classes.reslink2}>Home</Link> </ListItem>
               <ListItem key = {6} button divider>
               <a href="#haasprostaffinstallers" className={classes.reslink2}>HAAS Pro Staff Installers</a> </ListItem>
               <ListItem key = {7} button divider>
               <a href="#wheretobuy" className={classes.reslink2}>Where to Buy</a></ListItem> 
               <ListItem key = {7} button divider>
               <a href="#media" className={classes.reslink2}>Media</a></ListItem>
               <ListItem key = {7} button divider>
               <a href="#about" className={classes.reslink2}>About</a></ListItem>
               <ListItem key = {7} button divider>
               <a href="#stainlesssteelfacts" className={classes.reslink2}>Stainless Steel Facts</a></ListItem>
      </List>
    </div>
  );

  return (
    <div>             
        <Box	display={{ xs: 'block', md: 'none', sm: 'block', lg: 'none' }} >
      {['left'].map(anchor => (
        <React.Fragment key={anchor}>
            <AppBar  className={classes.color} >        
          <Toolbar >
            <Grid container direction = "row" justify = "space-between"  >            
              <MenuIcon style={{fontSize:'30px'}} onClick={toggleDrawer(anchor, true)}>{anchor}/></MenuIcon>          
          <Drawer anchor={anchor} open={state[anchor]} onClose={toggleDrawer(anchor, false)}>
            {list(anchor)}
          </Drawer>
          <Link to="/"> 
          <img src={logo} className={classes.reslogo} alt=""/></Link>
          </Grid>
          </Toolbar>
        </AppBar>
        </React.Fragment>
      ))}
      </Box>
    </div>
  );
}